/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {Text} from 'react-native';
import {handleDateValue} from '../../../../common/utils/date';
import {TitleLabel} from '../InputField/TitleLabel';
import styles from '../styles';
import './css/date.css';
import './css/styles.css';
interface Props {
  value?: any;
  required?: boolean;
  label?: string;
  error?: any;
  name?: any;
  showError?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  onChange: Function;
  isEditable?: boolean;
  type?: any;
  todayDate?: any;
  dateMin?: any;
  dateMax?: any;
  noInit?: boolean;
}

export const InputDatePicker: React.FC<Props> = ({
  value,
  required = false,
  label = '',
  error = '',
  name = '',
  showError = false,
  onChange,
  isEditable = true,
  type = 'date',
  dateMax,
  dateMin,
  noInit = false,
}) => {
  if (!noInit && !value) {
    value = new Date();
  }

  const yesterday = new Date();
  const futurDate = new Date();
  futurDate.setFullYear(futurDate.getFullYear());
  yesterday.setDate(yesterday.getDate() - 1);

  const handleChange = (name: string, date: any) => {
    onChange(name, date, true);
  };

  function addOneYear(date: Date, year: number = 10) {
    // Making a copy with the Date() constructor
    const dateCopy = new Date(date);

    dateCopy.setFullYear(dateCopy.getFullYear() + year);

    return dateCopy;
  }

  React.useEffect(() => {
    !value &&
      !noInit &&
      handleChange(name, dateMin ? dateMin.toISOString() : new Date());
  }, []);

  if (type && type === 'time') {
    return (
      <div
        className={
          required && showError && error !== '' ? 'inputError' : 'datetimeCss '
        }>
        <div className={isEditable ? '' : 'noEditable'}>
          <TitleLabel label={label} required={required} />
          <DatePicker
            dateFormat="HH:mm"
            selected={
              !value && noInit ? null : handleDateValue(value || new Date())
            }
            readOnly={!isEditable}
            onChange={(date: any) => {
              handleChange(name, date);
            }}
            showTimeSelect
            showTimeSelectOnly
            timeFormat="HH:mm"
            timeIntervals={5}
          />
        </div>

        {required && showError && error !== '' ? (
          <Text style={styles.textError}>{error}</Text>
        ) : null}
      </div>
    );
  } else {
    return (
      <div
        className={
          required && showError && error !== '' ? 'inputError' : 'datetimeCss '
        }>
        <div className={isEditable ? '' : 'noEditable'}>
          <TitleLabel
            style={{marginBottom: 5}}
            label={label}
            required={required}
          />
          <DatePicker
            dateFormat="dd/MM/yyyy"
            maxDate={
              dateMax
                ? handleDateValue(dateMax)
                : addOneYear(handleDateValue(dateMin))
            }
            minDate={dateMin ? handleDateValue(dateMin) : undefined}
            selected={
              !value && noInit ? null : handleDateValue(value || new Date())
            }
            readOnly={!isEditable}
            onChange={(date: any) => {
              handleChange(name, date);
            }}
            className="customDatePicker"
          />
        </div>
        {required && showError && error !== '' ? (
          <Text style={styles.textError}>{error}</Text>
        ) : null}
      </div>
    );
  }
};
